import { StepChangeEvent } from "../types/types";
import { BaseAddon, AddonParams } from "./base/BaseAddon";

export interface AddonConstructor<T extends string = string> {
  new (onNext: (event: StepChangeEvent) => void, onBack: any, params: AddonParams<T>): BaseAddon<T>;
  dependencies?: AddonConstructor<T>[];
}

export interface EntryAddonConstructor<T extends string = string> {
  new (onNext: (event: StepChangeEvent) => void, params: AddonParams<T>): BaseAddon<T>;
  dependencies?: AddonConstructor<T>[];
}

export interface IAddonRegistry<T extends string = string> {
  // core addons
  uploadAddon: EntryAddonConstructor<T>;
  selectSheetAddon: AddonConstructor<T>;
  selectHeaderAddon: AddonConstructor<T>;
  matchColumnsAddon: AddonConstructor<T>;
  validateDataAddon: AddonConstructor<T>;
  // entityRelationValidationAddon: AddonConstructor<T>;

  // rest addons
  [key: string]: AddonConstructor<T> | EntryAddonConstructor<T>;
}

export function resolveAddonDependencies<T extends string = string>(
  addons: (AddonConstructor<T> | EntryAddonConstructor<T>)[],
  registry: IAddonRegistry<T>
): (AddonConstructor<T> | EntryAddonConstructor<T>)[] {
  const resolvedAddons = new Set<AddonConstructor<T> | EntryAddonConstructor<T>>();

  // todo: make sure that if we add duplicate deps it doesnt break/infinite loop
  const addAddonWithDependencies = (addon: AddonConstructor<T> | EntryAddonConstructor<T>) => {
    if (resolvedAddons.has(addon)) return;

    if (addon?.dependencies) {
      addon.dependencies.forEach(dep => {
        if (dep) {
          addAddonWithDependencies(dep);
        }
      });
    }

    resolvedAddons.add(addon);
  };

  // core addons
  addAddonWithDependencies(registry.uploadAddon);
  addAddonWithDependencies(registry.selectSheetAddon);
  addAddonWithDependencies(registry.selectHeaderAddon);
  addAddonWithDependencies(registry.matchColumnsAddon);
  addAddonWithDependencies(registry.validateDataAddon);

  // rest of addons
  addons.forEach(addon => {
    addAddonWithDependencies(addon);
  });

  return Array.from(resolvedAddons);
}
